import { Component } from "react";
import PersonaFisica from "../Personas/PersonaFisica";
import PersonaJuridica from "../Personas/PersonaJuridica";
import IdentificacionesAsociadas from "../../Comunes/IdentificacionesAsociadas/IdentificacionesAsociadas";
import { _VerificarArray } from "../../../Utils/Funciones";
import ServicioAutorizaciones from "../../../servicios/Autorizaciones";
import {
  TIPO_PERSONA_CLASE_FISICA,
  TIPO_PERSONA_CLASE_JURIDICA,
} from "../../../Contenedores/Comun/VARIABLES";
import ParametroIncluirAutorizacion from "../../../Contenedores/Autorizaciones/ParametroIncluirAutorizacion";
import Identificacion from "../../../Contenedores/Comun/Identificacion";
import { CerrarNotificador, Notificar } from "../../Comunes/Notificador";
import TipoPersona from "../../../Contenedores/Comun/TipoPersona";
import DocumentosAutorizacionAdjuntar from "../../Comunes/Documentos/DocumentosAutorizacionAdjuntar";
import StickyTopBox from "../../Comunes/StickyBox/StickyTopBox";

export default class RegistroDeDatos extends Component {
  constructor(props) {
    super(props);

    this.state = {
      DatosPersona: [],
      DatosPersonaJuridica: [],
      DatosPersonaFisica: [],
      EsPersonaFisica: this.props.EsPersonaFisica,
      ClasePersona: this.props.EsPersonaFisica ? "F" : "J",
      MostrarInformacion: false,
      identificacionesAsociadas: [],
      Archivos: [],
    };

    this._GuardarAutorizacion = this._GuardarAutorizacion.bind(this);
  }

  async componentDidMount() {
    await this.cargarDatos();
  }

  async cargarDatos() {
    CerrarNotificador();
    if (!this.state.EsPersonaFisica) {
      this.CargarDatosPersonaJuridica();
    } else {
      this.cargarDatosPersonaFisica();
    }
  }

  async cargarDatosPersonaFisica() {
    let personaFisica = this.props.DatosDeBusquedaPersona;
    let IdentificacionesAsociadas = _VerificarArray(
      personaFisica.identificacionesAsociadas
    );

    this.setState({
      DatosPersonaFisica: personaFisica,
      MostrarInformacion: true,
      identificacionesAsociadas: IdentificacionesAsociadas,
    });
  }

  async CargarDatosPersonaJuridica() {
    let datosPersonaJuridica = this.props.DatosPersonaJuridica;
    let datosRepresentanteLegal = this.props.datosRepresentanteLegal;
    let IdentificacionesAsociadas = _VerificarArray(
      datosRepresentanteLegal.identificacionesAsociadas
    );

    this.setState({
      DatosPersonaJuridica: datosPersonaJuridica,
      DatosPersonaFisica: datosRepresentanteLegal,
      MostrarInformacion: true,
      identificacionesAsociadas: IdentificacionesAsociadas,
    });
  }

  async CargarParametros() {
    let parametro = new ParametroIncluirAutorizacion();
    parametro.NumeroAutorizacion = "";
    parametro.TipoAutorizacion = this.props.TipoAutorizacion;
    parametro.Documentos = this.state.Archivos;

    if (this.state.EsPersonaFisica) {
      parametro.Identificacion = new Identificacion();
      parametro.Identificacion.Codigo =
        this.state.DatosPersonaFisica.identificacionPrincipal.codigo;
      parametro.Identificacion.TipoPersona = new TipoPersona();
      parametro.Identificacion.TipoPersona.Codigo =
        this.state.DatosPersonaFisica.identificacionPrincipal.tipoPersona.codigo;
      parametro.Identificacion.TipoPersona.Clase = TIPO_PERSONA_CLASE_FISICA;

      parametro.RepresentanteLegal = null;
    } else {
      parametro.Identificacion = new Identificacion();
      parametro.Identificacion.Codigo =
        this.state.DatosPersonaJuridica.identificacionPrincipal.codigo;
      parametro.Identificacion.TipoPersona = new TipoPersona();
      parametro.Identificacion.TipoPersona.Codigo =
        this.state.DatosPersonaJuridica.identificacionPrincipal.tipoPersona.codigo;
      parametro.Identificacion.TipoPersona.Clase = TIPO_PERSONA_CLASE_JURIDICA;
      parametro.RepresentanteLegal = new Identificacion();
      parametro.RepresentanteLegal.Codigo =
        this.state.DatosPersonaFisica.identificacionPrincipal.codigo;
      parametro.RepresentanteLegal.TipoPersona = new TipoPersona();
      parametro.RepresentanteLegal.TipoPersona.Codigo =
        this.state.DatosPersonaFisica.identificacionPrincipal.tipoPersona.codigo;
    }
    return parametro;
  }

  async _GuardarAutorizacion() {
    CerrarNotificador();
    let parametro = await this.CargarParametros();
    var solicitud = await ServicioAutorizaciones.IncluirAutorizacion(parametro);
    if (solicitud.esValido) {
      this.props.VolverABusquedaPersona(solicitud.mensaje);
    } else {
      Notificar("error", solicitud.errores);
    }
  }

  onChangeDocumentos = (documentos) => {
    this.setState({ Archivos: documentos });
  };

  render() {
    return (
      <div>
        <StickyTopBox>
          <div className="row">
            <div className="col-auto">
              <button
                type="button"
                onClick={() => this.props.VolverABusquedaPersona("")}
                className="btn btn-sm btn-primary"
              >
                <i className="fas fa-arrow-circle-left"></i>
              </button>
            </div>

            <div className="col">
              <h1 className="h3 mb-0 text-gray-800">
                Datos Nueva Autorización
              </h1>
            </div>

            <div className="col text-right">
              <div>
                <button
                  type="button"
                  onClick={() => this._GuardarAutorizacion()}
                  className="btn btn-primary btn-icon-split text-center"
                >
                  <span className="icon text-white-50">
                    <i className="far fa-check-circle"></i>
                  </span>
                  <span className="text">Guardar Autorización</span>
                </button>
              </div>
            </div>
          </div>
        </StickyTopBox>

        {this.state.MostrarInformacion ? (
          <div>
            <div>
              {this.state.EsPersonaFisica ? (
                <PersonaFisica
                  DatosPersonaFisica={this.state.DatosPersonaFisica}
                />
              ) : (
                <>
                  <div>
                    <PersonaJuridica
                      PersonaJuridica={this.state.DatosPersonaJuridica}
                    />
                  </div>
                  <div>
                    <PersonaFisica
                      DatosPersonaFisica={this.state.DatosPersonaFisica}
                    />
                  </div>
                </>
              )}
            </div>
            <div id="identificacionesAsociadas">
              {this.state.identificacionesAsociadas != null ? (
                <IdentificacionesAsociadas
                  Identificaciones={this.state.identificacionesAsociadas}
                  Titulo={
                    this.state.EsPersonaFisica
                      ? "Identificaciones Asociadas"
                      : "Identificaciones Asociadas Representante Legal"
                  }
                />
              ) : null}
            </div>

            <div>
              <DocumentosAutorizacionAdjuntar
                clasePersona={this.state.ClasePersona}
                onChangeDocumentos={this.onChangeDocumentos}
              />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
